function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("d6vlx", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$9b8a65407e303a1c$export$2e2bcd8739ae039);
    var $cb25w;
    var $879xD;
    var $ecVFx;
    var $9sGI6;
    var $8n3se;
    var $bKCrm;
    var $daoB1;
    var $bhjVg;
    var $bS0ou;
    var $10Xc1;
    var $9b8a65407e303a1c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("9sGI6")).default)((0, (0, parcelRequire("cb25w")).default)({
        showSearch: (createAnalyticsEvent)=>(0, (0, parcelRequire("ecVFx")).keyboardShortcutPressed)({
                createAnalyticsEvent: createAnalyticsEvent,
                id: 'quickSearch',
                key: '/'
            }),
        showIssueCreate: (createAnalyticsEvent)=>(0, (0, parcelRequire("ecVFx")).keyboardShortcutPressed)({
                createAnalyticsEvent: createAnalyticsEvent,
                id: 'createIssue',
                key: 'c'
            }),
        navigateToIssueSearch: (createAnalyticsEvent)=>(0, (0, parcelRequire("ecVFx")).keyboardShortcutPressed)({
                createAnalyticsEvent: createAnalyticsEvent,
                id: 'findIssues',
                key: 'g i'
            }),
        navigateToMostRecentProject: (createAnalyticsEvent)=>(0, (0, parcelRequire("ecVFx")).keyboardShortcutPressed)({
                createAnalyticsEvent: createAnalyticsEvent,
                id: 'browseToProject',
                key: 'g p'
            })
    })((0, (0, parcelRequire("10Xc1")).default)), {
        navigateToIssueSearch: (0, parcelRequire("bhjVg")).navigateToIssueSearch,
        navigateToMostRecentProject: (0, parcelRequire("bhjVg")).navigateToMostRecentProject,
        ApplicationPermissionsSubscriber: (0, parcelRequire("daoB1")).ApplicationPermissionsSubscriber,
        KeyboardShortcutsDialog: (0, parcelRequire("bS0ou")).KeyboardShortcutsDialog,
        ProjectCreateDrawerConsumer: (0, parcelRequire("bKCrm")).ProjectCreateDrawerConsumer,
        Shortcuts: (0, parcelRequire("879xD")).CommandShortcuts,
        NavUIControllerSubscriber: (0, parcelRequire("8n3se")).UIControllerSubscriber
    });
});
parcelRegister("879xD", function(module, exports) {
    $parcel$export(module.exports, "CommandShortcuts", ()=>$6700f9962d7215c2$export$7ff7e4fe85a5960a);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Kt4o;
    var $556k7;
    var $jh7L9;
    var $3Tty1;
    const $6700f9962d7215c2$export$7ff7e4fe85a5960a = (props)=>{
        const { keyMap: keyMap } = props;
        const mappedCommands = (0, $5uXOq.useMemo)(()=>{
            const commands = [];
            Object.entries(keyMap).forEach(([key, mapItem])=>{
                if (!mapItem.registerInCommandPalette) return;
                const { primaryAction: primaryAction, ...command } = mapItem.registerInCommandPalette;
                let shortcutPrimaryAction;
                if (primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).COMMAND_LIST || primaryAction?.type === (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM) shortcutPrimaryAction = primaryAction;
                else if (mapItem.callback) shortcutPrimaryAction = {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                    perform: ()=>mapItem.callback()
                };
                commands.push({
                    id: `command-shortcut-${key}`,
                    shortcut: key,
                    ...command,
                    primaryAction: shortcutPrimaryAction
                });
            });
            return commands;
        }, [
            keyMap
        ]);
        const shortcutIds = (0, $5uXOq.useMemo)(()=>mappedCommands.map(({ id: id })=>id).toString(), [
            mappedCommands
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), props), !!mappedCommands.length && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("556k7")).RegisterCommands), {
            registrationId: (0, (0, parcelRequire("1Kt4o")).COMMAND_PALETTE_REGISTRY_IDS).SHORTCUTS,
            commands: mappedCommands,
            deps: [
                shortcutIds
            ]
        }));
    };
});
parcelRegister("556k7", function(module, exports) {
    $parcel$export(module.exports, "RegisterCommands", ()=>$ba0d6dd9c2ef02f6$export$cd555833c78729f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $buHQa;
    const $ba0d6dd9c2ef02f6$export$cd555833c78729f1 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("buHQa")).RegisterCommandsWithRegistry), props);
});
parcelRegister("buHQa", function(module, exports) {
    $parcel$export(module.exports, "RegisterCommandsWithRegistry", ()=>$3f4c8625aa6e8942$export$b8955a01360d2876);
    var $6QoIp;
    function $3f4c8625aa6e8942$export$b8955a01360d2876({ registrationId: registrationId, commands: commands, deps: deps }) {
        (0, (0, parcelRequire("6QoIp")).useRegisterCommandsWithRegistry)(registrationId, commands, deps);
        return null;
    }
});
parcelRegister("3Tty1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ba57d5dc6c0de0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9IeM0;
    var $4lkOX;
    var $h0GOb;
    var $k4r7E;
    var $9fuVs;
    var $kspvB;
    let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
    let $6ba57d5dc6c0de0a$var$subscription = null;
    const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
        const parentRegistry = (0, $5uXOq.useContext)((0, (0, parcelRequire("9fuVs")).ShortcutRegistryContext)) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                    keyMap: (0, (0, parcelRequire("kspvB")).bindKeyMapWithErrorHandling)(keyMap, location),
                    label: label
                })), [
            label,
            parentRegistry,
            keyMap,
            location
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
            const removeKeyMap = addKeyMap();
            return ()=>{
                removeKeyMap();
                $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
                if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                    $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                    $6ba57d5dc6c0de0a$var$subscription = null;
                }
            };
        }, [
            addKeyMap
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || (0, (0, parcelRequire("h0GOb")).default)().subscribe((0, (0, parcelRequire("4lkOX")).default));
        }, [
            parentRegistry,
            keyMap
        ]);
        return null;
    };
    var $6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, (0, parcelRequire("9IeM0")).useKeyboardShortcutsToggle), ...props })=>{
        const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
        return isEnabled && !false ? (0, ($parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
    };
});
parcelRegister("9IeM0", function(module, exports) {
    $parcel$export(module.exports, "useKeyboardShortcutsToggle", ()=>$dc712fc9bec05022$export$a33a81f1fc5458ad);
    var $jcw0u;
    var $eusud;
    var $j8DrX;
    var $8zOmE;
    var $3sQ5x;
    var $iXqE5;
    const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
    const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState().isEnabled;
            const status = currentState ? 'off' : 'on';
            const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)(url);
                setState({
                    isEnabled: !currentState,
                    error: null
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                    isEnabled: !currentState
                });
            } catch (err) {
                setState({
                    error: err
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'keyboardShortcutToggleFailure',
                        packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                    },
                    error: err
                });
            }
        };
    const $dc712fc9bec05022$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            isEnabled: false ? false : !((0, (0, parcelRequire("j8DrX")).default)('ajs-keyboard-shortcuts-enabled') === 'false'),
            error: null
        },
        actions: {
            toggle: $dc712fc9bec05022$export$b62f67be35e65859
        }
    });
    const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, (0, parcelRequire("3sQ5x")).createHook)($dc712fc9bec05022$var$Store);
});
parcelRegister("4lkOX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f11d50ddafbb6f85$export$2e2bcd8739ae039);
    var $h0GOb;
    var $k4r7E;
    const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
    var $f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
        const { sequence: sequence, e: e } = keySequence || {};
        const activeKeyMap = (0, (0, parcelRequire("k4r7E")).rootRegistry).getActiveKeyMap();
        if (sequence !== undefined && activeKeyMap[sequence]) {
            activeKeyMap[sequence].callback(e);
            (0, (0, parcelRequire("h0GOb")).flush)();
        } else {
            const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
            if (!isFutureMatchPossible) (0, (0, parcelRequire("h0GOb")).flush)();
        }
    };
});
parcelRegister("h0GOb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$849cd54ac4017470$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "flush", ()=>$849cd54ac4017470$export$4909b86c8034bf73);
    var $kVLXA = parcelRequire("kVLXA");
    var $cab1K = parcelRequire("cab1K");
    parcelRequire("jG6Un");
    parcelRequire("eSGL3");
    parcelRequire("1oQta");
    parcelRequire("4kRRr");
    parcelRequire("d0pqD");
    parcelRequire("iQCJJ");
    parcelRequire("fjPtF");
    parcelRequire("2R2to");
    var $lIZQG;
    const $849cd54ac4017470$var$ignoredKeys = {
        Control: true,
        Meta: true,
        Shift: true,
        Alt: true,
        AltGraph: true,
        CapsLock: true,
        Fn: true,
        FnLock: true,
        Hyper: true,
        NumLock: true,
        OS: true,
        ScrollLock: true,
        Super: true,
        Symbol: true,
        SymbolLock: true
    };
    const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
    const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
    const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
    const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
        const elBlankets = document.querySelectorAll('.aui-blanket');
        if (elBlankets.length === 0) return true;
        const isAllHidden = Array.from(elBlankets || []).every((el)=>{
            if (el.getAttribute('aria-hidden') === 'true' || el.getAttribute('hidden') !== null) return true;
            return false;
        });
        return isAllHidden;
    };
    let $849cd54ac4017470$var$key$;
    const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
    var $849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
        if (!$849cd54ac4017470$var$key$) {
            $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, (0, parcelRequire("lIZQG")).toKeyWithModifiers));
            const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
                if (!key || !seq) return undefined;
                return {
                    sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                    e: key.e
                };
            });
            $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
        }
        return $849cd54ac4017470$var$key$;
    };
    const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
        $849cd54ac4017470$var$flush$.next();
    };
});
parcelRegister("kspvB", function(module, exports) {
    $parcel$export(module.exports, "bindKeyMapWithErrorHandling", ()=>$f9e30ab2465f6f16$export$77477772a9b904da);
    var $dJl1T;
    const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
            try {
                callback(e);
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
            }
        };
    const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location)=>Object.keys(keyMap).reduce((map, key)=>({
                ...map,
                [key]: {
                    ...keyMap[key],
                    callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
                }
            }), {});
});
parcelRegister("ecVFx", function(module, exports) {
    $parcel$export(module.exports, "keyboardShortcutPressed", ()=>$a05167b676544212$export$32c6c6b79f098d3);
    $parcel$export(module.exports, "productNavigationExpandedCollapsed", ()=>$a05167b676544212$export$e2ad10d5be2f2400);
    var $e8KHW = parcelRequire("e8KHW");
    const $a05167b676544212$export$32c6c6b79f098d3 = ({ createAnalyticsEvent: createAnalyticsEvent, id: id, key: key, attributes: attributes = {} })=>{
        createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut',
            actionSubjectId: id,
            attributes: {
                navVersion: window.__NAV_VERSION__ || 'UNKNOWN',
                key: key,
                ...attributes
            }
        }).fire((0, $e8KHW.FabricChannel).navigation);
    };
    const $a05167b676544212$export$e2ad10d5be2f2400 = ({ createAnalyticsEvent: createAnalyticsEvent, isCollapsed: isCollapsed })=>{
        createAnalyticsEvent({
            action: isCollapsed ? 'expanded' : 'collapsed',
            actionSubject: 'productNavigation',
            attributes: {
                trigger: 'keyboardShortcut'
            }
        }).fire((0, $e8KHW.FabricChannel).navigation);
    };
});
parcelRegister("8n3se", function(module, exports) {
    $parcel$export(module.exports, "UIControllerSubscriber", ()=>$1bb3c61faedab1f7$export$8e3db525e646de2c);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $7XYc4;
    var $gPQRI;
    var $3HwlS;
    var $6qnkT;
    const $1bb3c61faedab1f7$var$UIControllerSubscriberOld = ({ children: children })=>{
        const { collapseLeftSidebar: collapseLeftSidebar, expandLeftSidebar: expandLeftSidebar } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarController)();
        const { isCollapsed: isCollapsed, width: width } = (0, (0, parcelRequire("gPQRI")).useLeftSidebarState)();
        const stateRef = (0, $5uXOq.useRef)({
            state: {
                isCollapsed: isCollapsed,
                isResizing: false,
                isResizeDisabled: false,
                productNavWidth: width
            },
            collapse: collapseLeftSidebar,
            expand: expandLeftSidebar,
            toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
        });
        const navigationUIController = (0, $5uXOq.useMemo)(()=>({
                state: {
                    isCollapsed: isCollapsed,
                    isResizing: false,
                    isResizeDisabled: false,
                    productNavWidth: width
                },
                collapse: collapseLeftSidebar,
                expand: expandLeftSidebar,
                toggleCollapse: ()=>isCollapsed ? expandLeftSidebar() : collapseLeftSidebar()
            }), [
            collapseLeftSidebar,
            expandLeftSidebar,
            isCollapsed,
            width
        ]);
        stateRef.current = Object.assign(stateRef.current, navigationUIController);
        return children(stateRef.current);
    };
    const $1bb3c61faedab1f7$var$defaultState = {
        state: {
            isCollapsed: false,
            isResizing: false,
            isResizeDisabled: false,
            productNavWidth: 0
        },
        collapse: (0, ($parcel$interopDefault($8Rkzz))),
        expand: (0, ($parcel$interopDefault($8Rkzz))),
        toggleCollapse: (0, ($parcel$interopDefault($8Rkzz)))
    };
    const $1bb3c61faedab1f7$var$UIControllerSubscriberNew = ({ children: children })=>{
        const toggleSideNav = (0, (0, parcelRequire("6qnkT")).useToggleSideNav)();
        const stateRef = (0, $5uXOq.useRef)({
            ...$1bb3c61faedab1f7$var$defaultState,
            toggleCollapse: toggleSideNav
        });
        const navigationUIController = (0, $5uXOq.useMemo)(()=>({
                ...$1bb3c61faedab1f7$var$defaultState,
                toggleCollapse: toggleSideNav
            }), [
            toggleSideNav
        ]);
        stateRef.current = Object.assign(stateRef.current, navigationUIController);
        return children(stateRef.current);
    };
    const $1bb3c61faedab1f7$export$8e3db525e646de2c = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("3HwlS")).getWillShowNav4), $1bb3c61faedab1f7$var$UIControllerSubscriberNew, $1bb3c61faedab1f7$var$UIControllerSubscriberOld);
});
parcelRegister("bhjVg", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_SEARCH_PATH", ()=>$6d6d8fa3685e2d1e$export$160e2509706f1f3d);
    $parcel$export(module.exports, "navigateToIssueSearch", ()=>$6d6d8fa3685e2d1e$export$722548870edd83a4);
    $parcel$export(module.exports, "navigateToMostRecentProject", ()=>$6d6d8fa3685e2d1e$export$6e7d070c02020dbd);
    var $eusud;
    const $6d6d8fa3685e2d1e$export$160e2509706f1f3d = '/issues/';
    const $6d6d8fa3685e2d1e$export$722548870edd83a4 = ()=>window.open($6d6d8fa3685e2d1e$export$160e2509706f1f3d, '_self');
    const $6d6d8fa3685e2d1e$export$6e7d070c02020dbd = ()=>(0, (0, parcelRequire("eusud")).performGetRequest)('/rest/internal/2/productsearch/search?type=projects').then((data)=>{
            const section = data.find(({ id: id })=>id === 'quick-search-projects');
            if (section && section.items && section.items[0] && section.items[0].url) window.open(section.items[0].url, '_self');
        });
});
parcelRegister("bS0ou", function(module, exports) {
    $parcel$export(module.exports, "KeyboardShortcutsDialog", ()=>$155f20bdf996fb89$export$dc5d1c021e0a8741);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $kxZPA;
    const $155f20bdf996fb89$var$KeyboardShortcutsDialogLazy = (0, (0, parcelRequire("kxZPA")).lazy)(()=>(parcelRequire("drtQx")), {
        ssr: false,
        moduleId: "./src/packages/common/components/keyboard-shortcuts-dialog/src/index.tsx"
    });
    const $155f20bdf996fb89$export$dc5d1c021e0a8741 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "integrations.keyboard-shortcuts-dialog",
            packageName: "jira-keyboard-shortcuts",
            fallback: "unmount"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "keyboard-shortcuts.dialog",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($155f20bdf996fb89$var$KeyboardShortcutsDialogLazy, props)));
});
parcelRegister("drtQx", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("7w76i").then(()=>parcelRequire('9RznK'));
});
parcelRegister("10Xc1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$845ba24b23c70475$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7ymNM;
    var $8RBk4;
    var $lRPYt;
    var $7QGmb;
    var $5p1kJ;
    var $4l54H;
    var $5rVQI;
    var $eG9rp;
    var $ecVFx;
    var $4R6GH;
    var $6BNJk;
    var $ousew;
    var $koVbs;
    var $jRhyQ;
    var $3HwlS;
    var $4DPZY;
    var $bhjVg;
    var $kTq0U;
    var $flygU;
    class $845ba24b23c70475$var$KeyboardShortcuts extends (0, $5uXOq.Component) {
        getKeyMap({ toggleHelpPanel: toggleHelpPanel, openKeyboardShortcutsDialog: openKeyboardShortcutsDialog, toggleCollapse: toggleCollapse, isNextGen: isNextGen }) {
            const { navigateToIssueSearch: navigateToIssueSearch, navigateToMostRecentProject: navigateToMostRecentProject, showIssueCreate: showIssueCreate, showSearch: showSearch, shouldUseHelpShortcut: shouldUseHelpShortcut, formatMessage: formatMessage, getKeywords: getKeywords } = this.props;
            const keys = isNextGen === true ? {
                '?': {
                    callback: openKeyboardShortcutsDialog,
                    registerInCommandPalette: {
                        name: formatMessage((0, (0, parcelRequire("kTq0U")).default).keyboardShortcutsCommandPalette),
                        keywords: getKeywords('viewKeyboardShortcutsSynonyms'),
                        priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_HELP_PRIORITY).viewKeyboardShortcuts,
                        section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).help,
                        components: {
                            LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lRPYt"))))), {
                                    label: formatMessage((0, (0, parcelRequire("kTq0U")).default).keyboardShortcutsCommandPalette)
                                })
                        },
                        analytics: {
                            action: (0, $d2e2fe4ac38ba530$export$e0515b3bb1ce3f33)
                        },
                        ...(0, (0, parcelRequire("4R6GH")).fg)('compal-ktlo-improvements-1') ? {
                            id: 'keyboard-shortcuts.open'
                        } : {}
                    }
                },
                '/': {
                    callback: showSearch
                },
                '[': {
                    callback: toggleCollapse
                },
                escape: {
                    callback: ()=>{}
                },
                'g p': {
                    callback: ()=>navigateToMostRecentProject()
                },
                'g i': {
                    callback: ()=>navigateToIssueSearch(),
                    registerInCommandPalette: this.props.hideAndTransformNavigationCommand({
                        command: {
                            id: 'find-issues',
                            name: formatMessage((0, (0, parcelRequire("kTq0U")).default).viewAllIssues),
                            keywords: getKeywords('viewAllIssuesSynonyms'),
                            priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).viewAllIssues,
                            section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).siteNavigation,
                            components: {
                                LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                                        label: formatMessage((0, (0, parcelRequire("kTq0U")).default).viewAllIssues)
                                    })
                            },
                            analytics: {
                                action: (0, $d2e2fe4ac38ba530$export$5f007fc3736b8e2b)
                            }
                        },
                        hideCommandPath: (0, (0, parcelRequire("bhjVg")).ISSUE_SEARCH_PATH),
                        path: (0, (0, parcelRequire("bhjVg")).ISSUE_SEARCH_PATH)
                    })
                },
                c: {
                    callback: showIssueCreate,
                    registerInCommandPalette: {
                        name: formatMessage((0, (0, parcelRequire("kTq0U")).default).createIssue),
                        keywords: getKeywords('createIssueSynonyms'),
                        priority: (0, (0, parcelRequire("5rVQI")).COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).createIssue,
                        section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).quickActions,
                        components: {
                            LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7ymNM"))))), {
                                    label: formatMessage((0, (0, parcelRequire("kTq0U")).default).createIssue)
                                })
                        },
                        analytics: {
                            action: (0, $d2e2fe4ac38ba530$export$4e353cf4f7beb2cd)
                        },
                        ...(0, (0, parcelRequire("4R6GH")).fg)('compal-ktlo-improvements-1') ? {
                            id: 'keyboard-shortcuts.create-issue'
                        } : {}
                    }
                },
                ...shouldUseHelpShortcut && __SPA__ ? {
                    h: {
                        callback: toggleHelpPanel,
                        registerInCommandPalette: {
                            name: formatMessage((0, (0, parcelRequire("kTq0U")).default).getHelp),
                            keywords: getKeywords('getHelpSynonyms'),
                            priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_HELP_PRIORITY).getHelp,
                            section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).help,
                            components: {
                                LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7QGmb"))))), {
                                        label: formatMessage((0, (0, parcelRequire("kTq0U")).default).getHelp)
                                    })
                            },
                            analytics: {
                                action: (0, $d2e2fe4ac38ba530$export$42dbd0c9d165bb55)
                            },
                            ...(0, (0, parcelRequire("4R6GH")).fg)('compal-ktlo-improvements-1') ? {
                                id: 'keyboard-shortcuts.help'
                            } : {}
                        }
                    }
                } : null
            } : {
                '/': {
                    callback: showSearch,
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kTq0U")).default).quickSearch)
                },
                escape: {
                    callback: ()=>{},
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kTq0U")).default).closeDrawer)
                },
                c: {
                    callback: showIssueCreate,
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kTq0U")).default).createIssue),
                    registerInCommandPalette: {
                        name: formatMessage((0, (0, parcelRequire("kTq0U")).default).createIssue),
                        keywords: getKeywords('createIssueSynonyms'),
                        section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).quickActions,
                        priority: (0, (0, parcelRequire("5rVQI")).COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).createIssue,
                        components: {
                            LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7ymNM"))))), {
                                    label: formatMessage((0, (0, parcelRequire("kTq0U")).default).createIssue)
                                })
                        },
                        analytics: {
                            action: (0, $d2e2fe4ac38ba530$export$4e353cf4f7beb2cd)
                        },
                        ...(0, (0, parcelRequire("4R6GH")).fg)('compal-ktlo-improvements-1') ? {
                            id: 'keyboard-shortcuts.create-issue'
                        } : {}
                    }
                },
                '?': {
                    callback: openKeyboardShortcutsDialog,
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kTq0U")).default).keyboardShortcuts),
                    registerInCommandPalette: {
                        name: formatMessage((0, (0, parcelRequire("kTq0U")).default).keyboardShortcutsCommandPalette),
                        keywords: getKeywords('viewKeyboardShortcutsSynonyms'),
                        priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_HELP_PRIORITY).viewKeyboardShortcuts,
                        section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).help,
                        components: {
                            LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("lRPYt"))))), {
                                    label: formatMessage((0, (0, parcelRequire("kTq0U")).default).keyboardShortcutsCommandPalette)
                                })
                        },
                        analytics: {
                            action: (0, $d2e2fe4ac38ba530$export$e0515b3bb1ce3f33)
                        },
                        ...(0, (0, parcelRequire("4R6GH")).fg)('compal-ktlo-improvements-1') ? {
                            id: 'keyboard-shortcuts.open'
                        } : {}
                    }
                },
                'g i': {
                    callback: ()=>navigateToIssueSearch(),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kTq0U")).default).findIssues),
                    registerInCommandPalette: this.props.hideAndTransformNavigationCommand({
                        command: {
                            id: 'find-issues',
                            name: formatMessage((0, (0, parcelRequire("kTq0U")).default).viewAllIssues),
                            keywords: getKeywords('viewAllIssuesSynonyms'),
                            priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SITE_NAVIGATION_PRIORITY).viewAllIssues,
                            section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).siteNavigation,
                            components: {
                                LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("8RBk4"))))), {
                                        label: formatMessage((0, (0, parcelRequire("kTq0U")).default).viewAllIssues)
                                    })
                            },
                            analytics: {
                                action: (0, $d2e2fe4ac38ba530$export$5f007fc3736b8e2b)
                            }
                        },
                        hideCommandPath: (0, (0, parcelRequire("bhjVg")).ISSUE_SEARCH_PATH),
                        path: (0, (0, parcelRequire("bhjVg")).ISSUE_SEARCH_PATH)
                    })
                },
                'g p': {
                    callback: ()=>navigateToMostRecentProject(),
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kTq0U")).default).browseAProject)
                },
                '[': {
                    callback: toggleCollapse,
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kTq0U")).default).toggleSidebar)
                },
                ...shouldUseHelpShortcut && __SPA__ ? {
                    h: {
                        callback: toggleHelpPanel,
                        label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kTq0U")).default).openHelpPanel),
                        registerInCommandPalette: {
                            name: formatMessage((0, (0, parcelRequire("kTq0U")).default).getHelp),
                            keywords: getKeywords('getHelpSynonyms'),
                            priority: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_HELP_PRIORITY).getHelp,
                            section: (0, (0, parcelRequire("5p1kJ")).COMMAND_PALETTE_SECTIONS).help,
                            components: {
                                LeftIcon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7QGmb"))))), {
                                        label: formatMessage((0, (0, parcelRequire("kTq0U")).default).getHelp)
                                    })
                            },
                            analytics: {
                                action: (0, $d2e2fe4ac38ba530$export$42dbd0c9d165bb55)
                            },
                            ...(0, (0, parcelRequire("4R6GH")).fg)('compal-ktlo-improvements-1') ? {
                                id: 'keyboard-shortcuts.help'
                            } : {}
                        }
                    }
                } : null,
                [`${(0, (0, parcelRequire("flygU")).getShortcutModifierKey)()}+k`]: {
                    callback: ()=>{},
                    label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kTq0U")).default).openCommandPalette),
                    priority: -1
                }
            };
            return keys;
        }
        createToggleCollapse(navAPI) {
            return ()=>{
                if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) {
                    const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                    const { state: { isCollapsed: isCollapsed }, toggleCollapse: toggleCollapse } = navAPI;
                    (0, (0, parcelRequire("ecVFx")).keyboardShortcutPressed)({
                        createAnalyticsEvent: createAnalyticsEvent,
                        id: 'expandCollapseSidebar',
                        key: '['
                    });
                    (0, (0, parcelRequire("ecVFx")).productNavigationExpandedCollapsed)({
                        createAnalyticsEvent: createAnalyticsEvent,
                        isCollapsed: isCollapsed
                    });
                    toggleCollapse();
                } else {
                    const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                    const { state: { isCollapsed: isCollapsed }, toggleCollapse: toggleCollapse } = navAPI;
                    const contextualNavigation = document.querySelector('[data-testid="ContextualNavigation"]');
                    const isVisible = contextualNavigation && contextualNavigation.style.width !== '0px';
                    if (isVisible === true) {
                        (0, (0, parcelRequire("ecVFx")).keyboardShortcutPressed)({
                            createAnalyticsEvent: createAnalyticsEvent,
                            id: 'expandCollapseSidebar',
                            key: '['
                        });
                        (0, (0, parcelRequire("ecVFx")).productNavigationExpandedCollapsed)({
                            createAnalyticsEvent: createAnalyticsEvent,
                            isCollapsed: isCollapsed
                        });
                        toggleCollapse();
                    }
                }
            };
        }
        createToggleHelpPanel(isNextGen) {
            return ()=>{
                const { createAnalyticsEvent: createAnalyticsEvent, toggleHelpPanel: toggleHelpPanel } = this.props;
                (0, (0, parcelRequire("ecVFx")).keyboardShortcutPressed)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    id: 'openHelpPanel',
                    key: 'h',
                    attributes: {
                        helpPanelVersion: (0, (0, parcelRequire("6BNJk")).HELP_PANEL_VERSION),
                        helpPanelType: 'inProductHelp',
                        nextGenProject: isNextGen
                    }
                });
                toggleHelpPanel();
            };
        }
        createOpenKeyboardShortcutsDialog(openDialog) {
            return ()=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = this.props;
                (0, (0, parcelRequire("ecVFx")).keyboardShortcutPressed)({
                    createAnalyticsEvent: createAnalyticsEvent,
                    id: 'keyboardShortcuts',
                    key: '?'
                });
                openDialog();
            };
        }
        render() {
            const { ApplicationPermissionsSubscriber: ApplicationPermissionsSubscriber, KeyboardShortcutsDialog: KeyboardShortcutsDialog, ProjectCreateDrawerConsumer: ProjectCreateDrawerConsumer, Shortcuts: Shortcuts, NavUIControllerSubscriber: NavUIControllerSubscriber } = this.props;
            return ((0, ($parcel$interopDefault($5uXOq))).createElement(ApplicationPermissionsSubscriber, null, ({ data: data })=>(0, ($parcel$interopDefault($5uXOq))).createElement(ProjectCreateDrawerConsumer, null, ({ data: { isOpen: isOpen } })=>isOpen ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jRhyQ")).ModalsContainer), {
                        scope: "keyboard-shortcuts"
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jRhyQ")).ModalsSubscriber), null, (isKeyboardShortcutsDialogOpen, { open: open, close: close })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4DPZY")).ContainerContextSubscriber), null, ({ data: contextData })=>{
                            const isNextGen = contextData && contextData.contextType === 'project' ? contextData.project.isSimplified : false;
                            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isKeyboardShortcutsDialogOpen && (0, ($parcel$interopDefault($5uXOq))).createElement(KeyboardShortcutsDialog, {
                                isOpen: true,
                                onDialogDismissed: close,
                                applicationPermissionData: data.applicationPermissions,
                                isNextGen: isNextGen,
                                shouldUseHelpShortcut: true
                            }), (0, ($parcel$interopDefault($5uXOq))).createElement(NavUIControllerSubscriber, null, (navAPI)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Shortcuts, {
                                    isSpa: __SPA__,
                                    label: isNextGen ? null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), (0, (0, parcelRequire("kTq0U")).default).globalShortcuts),
                                    keyMap: this.getKeyMap({
                                        toggleHelpPanel: this.createToggleHelpPanel(isNextGen),
                                        openKeyboardShortcutsDialog: this.createOpenKeyboardShortcutsDialog(open),
                                        toggleCollapse: this.createToggleCollapse(navAPI),
                                        isNextGen: isNextGen
                                    })
                                })));
                        }))))));
        }
    }
    const $845ba24b23c70475$export$89fa8f7790ea1f0e = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { hideAndTransformNavigationCommand: hideAndTransformNavigationCommand } = (0, (0, parcelRequire("4l54H")).useTransformNavigationCommands)();
        const { getKeywords: getKeywords } = (0, (0, parcelRequire("eG9rp")).useCommandKeywords)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($845ba24b23c70475$var$KeyboardShortcuts, {
            formatMessage: formatMessage,
            hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
            getKeywords: getKeywords,
            ...props
        });
    };
    var $845ba24b23c70475$export$2e2bcd8739ae039 = $845ba24b23c70475$export$89fa8f7790ea1f0e;
});
parcelRegister("7ymNM", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $57fd655943aa23fe$var$_react = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $57fd655943aa23fe$var$_add = $57fd655943aa23fe$var$_interopRequireDefault((parcelRequire("dZbEw")));
    function $57fd655943aa23fe$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $57fd655943aa23fe$var$AddIcon = (props)=>$57fd655943aa23fe$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13 11V3.993A.997.997 0 0 0 12 3c-.556 0-1 .445-1 .993V11H3.993A.997.997 0 0 0 3 12c0 .557.445 1 .993 1H11v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V13h7.007A.997.997 0 0 0 21 12c0-.556-.445-1-.993-1z"/></svg>`
        }, props, {
            newIcon: $57fd655943aa23fe$var$_add.default
        }));
    $57fd655943aa23fe$var$AddIcon.displayName = 'AddIcon';
    var $57fd655943aa23fe$var$_default = module.exports.default = $57fd655943aa23fe$var$AddIcon;
});
parcelRegister("8RBk4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
    function $6740397d4ba98b13$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>$6740397d4ba98b13$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
        }, props, {
            newIcon: $6740397d4ba98b13$var$_arrowRight.default
        }));
    $6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;
});
parcelRegister("h1TKi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c65dc59efb96b35a$var$_UNSAFE_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>$c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;
});
parcelRegister("lRPYt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $feb6dd38b103e72a$var$_react = $feb6dd38b103e72a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $feb6dd38b103e72a$var$_textStyle = $feb6dd38b103e72a$var$_interopRequireDefault((parcelRequire("kauzw")));
    function $feb6dd38b103e72a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $feb6dd38b103e72a$var$EmojiKeyboardIcon = (props)=>$feb6dd38b103e72a$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m5.84 6.95-3.82 9.97a.5.5 0 0 0 .47.68H3.7a.5.5 0 0 0 .47-.33l.68-1.88a.5.5 0 0 1 .47-.33h3.8a.5.5 0 0 1 .47.33l.68 1.88a.5.5 0 0 0 .47.33h1.27a.5.5 0 0 0 .47-.68L8.69 6.95a.7.7 0 0 0-.66-.45H6.49a.7.7 0 0 0-.65.45m1.57 2.46 1.25 3.41a.2.2 0 0 1-.19.27h-2.5a.2.2 0 0 1-.19-.27l1.25-3.41a.2.2 0 0 1 .38 0m10.14 6.46c1.22 0 2.14-1.01 2.14-2.6s-.9-2.53-2.14-2.53c-1.26 0-2.18.94-2.18 2.53 0 1.58.9 2.6 2.18 2.6m2.16.6c-.37.83-1.28 1.43-2.44 1.43-2.57 0-4.27-2-4.27-4.64 0-2.55 1.66-4.57 4.2-4.57 1.56 0 2.28.83 2.5 1.33v-.34c0-.25.01-.39.21-.58q.21-.18.62-.16h.76a.58.58 0 0 1 .5.17c.21.2.19.42.19.58v6.39q0 .34.02.9 0 .29-.12.43a.63.63 0 0 1-.51.24h-.93c-.19 0-.45-.08-.53-.18s-.16-.23-.18-.53a6 6 0 0 1-.01-.36z"/></svg>`
        }, props, {
            newIcon: $feb6dd38b103e72a$var$_textStyle.default
        }));
    $feb6dd38b103e72a$var$EmojiKeyboardIcon.displayName = 'EmojiKeyboardIcon';
    var $feb6dd38b103e72a$var$_default = module.exports.default = $feb6dd38b103e72a$var$EmojiKeyboardIcon;
});
parcelRegister("kauzw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $eaec74c566e8a5e8$var$_react = $eaec74c566e8a5e8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $eaec74c566e8a5e8$var$_UNSAFE_baseNew = $eaec74c566e8a5e8$var$_interopRequireDefault((parcelRequire("fEaCe")));
    function $eaec74c566e8a5e8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $eaec74c566e8a5e8$var$TextStyleIcon = (props)=>$eaec74c566e8a5e8$var$_react.default.createElement($eaec74c566e8a5e8$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M3.75 11v-.375L5.032 7.25M12.25 11v-.375L10.974 7.25m0 0L8.518.75H7.5l-2.468 6.5m5.942 0H5.032"/>`
        }, props));
    $eaec74c566e8a5e8$var$TextStyleIcon.displayName = 'TextStyleIcon';
    var $eaec74c566e8a5e8$var$_default = module.exports.default = $eaec74c566e8a5e8$var$TextStyleIcon;
});
parcelRegister("7QGmb", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5b6e3ee3ed88bbe3$var$_react = $5b6e3ee3ed88bbe3$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $5b6e3ee3ed88bbe3$var$_questionCircle = $5b6e3ee3ed88bbe3$var$_interopRequireDefault((parcelRequire("8nk07")));
    function $5b6e3ee3ed88bbe3$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5b6e3ee3ed88bbe3$var$QuestionIcon = (props)=>$5b6e3ee3ed88bbe3$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M12 18a1 1 0 0 1 0-2 1 1 0 0 1 0 2m-2-9a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/><path d="M15.89 8.048a3.97 3.97 0 0 0-2.951-2.94A4.005 4.005 0 0 0 8 9.087l.009.008 1.878.022.112-.116A2 2 0 0 1 12 7c1.103 0 2 .897 2 2s-.897 2-2 2h.008a1 1 0 0 0-.998.987v2.014a1 1 0 1 0 2 0v-.782c0-.217.145-.399.349-.472a3.99 3.99 0 0 0 2.53-4.699"/></g></svg>`
        }, props, {
            newIcon: $5b6e3ee3ed88bbe3$var$_questionCircle.default
        }));
    $5b6e3ee3ed88bbe3$var$QuestionIcon.displayName = 'QuestionIcon';
    var $5b6e3ee3ed88bbe3$var$_default = module.exports.default = $5b6e3ee3ed88bbe3$var$QuestionIcon;
});
parcelRegister("4l54H", function(module, exports) {
    $parcel$export(module.exports, "useTransformNavigationCommands", ()=>$586d7e6f1a99cb44$export$5b108cd54c923a60);
    var $5uXOq = parcelRequire("5uXOq");
    var $2NMNM;
    var $7paD5;
    var $kgoHi;
    var $8CUq3;
    var $jh7L9;
    var $jiSaf;
    var $gM5ou;
    var $d8lE2;
    var $2f2jJ;
    var $4R6GH;
    var $8zOmE;
    var $dCm1o;
    var $doZTA;
    var $8btEA;
    var $3XsL2;
    var $d10H0;
    var $dmcoI;
    const $586d7e6f1a99cb44$export$5b108cd54c923a60 = ()=>{
        const [{ location: { pathname: pathname } }, { push: push, pushTo: pushTo }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { getAnalyticsAttributes: getAnalyticsAttributes } = (0, (0, parcelRequire("d8lE2")).useActionsCommandPalette)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const openNewTab = (0, $5uXOq.useCallback)((link, openBackground)=>{
            const url = typeof link === 'string' ? link : link.path;
            const newTab = window.open(url, '_blank');
            if (openBackground) {
                newTab?.blur();
                window.focus();
            }
            return newTab;
        }, []);
        const openSameTab = (0, $5uXOq.useCallback)((link)=>{
            if (typeof link === 'string') return push(link);
            return pushTo(link);
        }, [
            push,
            pushTo
        ]);
        const renderCommand = (0, $5uXOq.useCallback)((props, path, shouldAlwaysOpenNewTab)=>{
            const { onClick: onClick, ...rest } = props;
            const { command: command } = rest;
            const handleClick = (event)=>{
                const wasSecondaryTriggered = (0, (0, parcelRequire("gM5ou")).isSecondaryTrigger)(event);
                if (!wasSecondaryTriggered) {
                    onClick?.(event);
                    event.preventDefault();
                    return;
                }
                const analytics = getAnalyticsAttributes(command, 'mouse', wasSecondaryTriggered, props?.analyticsAttributes);
                const eventAnalytics = createAnalyticsEvent({});
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(eventAnalytics, 'commandPalette navigation', analytics);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(eventAnalytics, 'commandPalette secondaryAction', {
                    ...analytics,
                    keyPressed: (0, (0, parcelRequire("2f2jJ")).isMacOs)() ? 'cmdEnter' : 'ctrlEnter',
                    secondaryAction: 'openNewTab'
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(eventAnalytics, 'commandPalette taskSucceeded', analytics);
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3XsL2")).NavigationLink), {
                to: path,
                onClick: handleClick,
                ...shouldAlwaysOpenNewTab && {
                    target: '_blank'
                },
                "data-testid": (0, $2ea3babd020e8e8a$export$8db96ea7b6a4cbab),
                ...(0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? {} : {
                    tabIndex: -1
                }
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jiSaf")).components).CommandRow, rest));
        }, [
            createAnalyticsEvent,
            getAnalyticsAttributes
        ]);
        const transformNavigationCommand = (0, $5uXOq.useCallback)((command, { path: path, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab })=>({
                ...command,
                components: {
                    ...command.components,
                    Name: (base)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8btEA")).NameContainer), null, command.components?.Name ? (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.Name, base) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, command.name), !!shouldAlwaysOpenNewTab && (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                            testId: (0, $2ea3babd020e8e8a$export$99957d8f5f113509),
                            justifyContent: "center",
                            alignItems: "center",
                            xcss: $586d7e6f1a99cb44$var$iconWrapperStyles
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7paD5"))))), {
                            label: "",
                            color: "currentColor"
                        })), !!shouldAlwaysOpenNewTab && !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8btEA")).IconContainer), {
                            "data-testid": (0, $2ea3babd020e8e8a$export$99957d8f5f113509)
                        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7paD5"))))), {
                            label: "",
                            color: "currentColor"
                        }))),
                    CommandRow: (base)=>renderCommand(base, path, shouldAlwaysOpenNewTab),
                    Footer: (0, (0, parcelRequire("d10H0")).NewTabHintMessage)
                },
                primaryAction: {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                    perform: ()=>shouldAlwaysOpenNewTab ? openNewTab(path) : openSameTab(path)
                },
                secondaryAction: {
                    type: (0, (0, parcelRequire("jh7L9")).CommandActionType).PERFORM,
                    perform: ()=>openNewTab(path, true),
                    preventModalClose: true,
                    analyticsArgs: {
                        secondaryAction: 'openNewTab'
                    }
                }
            }), [
            openNewTab,
            openSameTab,
            renderCommand
        ]);
        const shouldShowCommand = (0, $5uXOq.useCallback)((hideCommandPath)=>!(0, (0, parcelRequire("dmcoI")).isCurrentPage)(hideCommandPath, pathname), [
            pathname
        ]);
        const hideAndTransformNavigationCommand = (0, $5uXOq.useCallback)((commandToTransform)=>{
            const { path: path, hideCommandPath: hideCommandPath, shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab, command: command } = commandToTransform;
            let hidePath = typeof path === 'string' ? path : path.path;
            if (hideCommandPath) hidePath = hideCommandPath;
            if (!shouldShowCommand(hidePath)) return undefined;
            return transformNavigationCommand(command, {
                path: path,
                shouldAlwaysOpenNewTab: shouldAlwaysOpenNewTab
            });
        }, [
            shouldShowCommand,
            transformNavigationCommand
        ]);
        const hideAndTransformNavigationCommands = (0, $5uXOq.useCallback)((commands)=>{
            const filteredCommands = [];
            commands.forEach((commandToTransform)=>{
                const transformedCommand = hideAndTransformNavigationCommand(commandToTransform);
                if (transformedCommand) filteredCommands.push(transformedCommand);
            });
            return filteredCommands;
        }, [
            hideAndTransformNavigationCommand
        ]);
        return {
            shouldShowCommand: shouldShowCommand,
            hideAndTransformNavigationCommand: hideAndTransformNavigationCommand,
            hideAndTransformNavigationCommands: hideAndTransformNavigationCommands,
            transformNavigationCommand: transformNavigationCommand
        };
    };
    const $586d7e6f1a99cb44$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '24px',
        width: '24px',
        marginLeft: 'space.075'
    });
});
parcelRegister("jiSaf", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$44cb4d9bf5d8b8a6$export$9b5ac10f59f76296);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $dOktC;
    var $haBRL;
    var $dE25F;
    var $d4iCz;
    const $44cb4d9bf5d8b8a6$var$NameComponent = ({ children: children, ...rest })=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('fix_compal_name_wrapper')) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), rest, children);
    };
    const $44cb4d9bf5d8b8a6$export$9b5ac10f59f76296 = {
        CommandRow: (0, parcelRequire("haBRL")).CommandRow,
        Name: $44cb4d9bf5d8b8a6$var$NameComponent,
        LeftIcon: (0, $5uXOq.Fragment),
        Wrapper: (0, $5uXOq.Fragment),
        Footer: (0, parcelRequire("dE25F")).Footer,
        Body: (0, (0, parcelRequire("dOktC")).CommandPaletteBody),
        Header: (0, parcelRequire("d4iCz")).Header
    };
});
parcelRegister("dOktC", function(module, exports) {
    $parcel$export(module.exports, "NoResultsContainer", ()=>$2bc4c9970ded9a96$export$2ab569a6937cb4e4);
    $parcel$export(module.exports, "CommandPaletteBody", ()=>$2bc4c9970ded9a96$export$b1023de69a8756e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $2NMNM;
    var $4R6GH;
    var $d8lE2;
    var $gM5ou;
    var $bYCTm;
    var $38IFv;
    var $cLshs;
    var $4nfzy;
    var $eKTyH;
    var $5aF2z;
    var $64ZBB;
    const $2bc4c9970ded9a96$var$CommandPaletteChildren = ({ results: results, noResultsFallback: noResultsFallback, renderAfterCommands: renderAfterCommands, resultsRefs: resultsRefs })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("2NMNM")).useAnalyticsEvents)();
        const [{ isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, removeCommandsById: removeCommandsById, executeCommand: executeCommand }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const onHoverCommand = (index)=>{
            if (index === undefined) return;
            setActiveIndex(index);
        };
        const onMouseDownCommand = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
        }, []);
        const onClickCommand = (0, $5uXOq.useCallback)((event, result)=>{
            executeCommand(result.command, {
                method: 'mouse',
                createAnalyticsEvent: createAnalyticsEvent,
                attributes: {
                    ...(0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromResult)(result),
                    ...(0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, result?.command.id)
                }
            }, (0, (0, parcelRequire("gM5ou")).isSecondaryTrigger)(event));
        }, [
            activeRegistry,
            createAnalyticsEvent,
            executeCommand,
            registry
        ]);
        const localResultRefs = resultsRefs.current;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !loadingList && noResultsFallback && (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$export$2ab569a6937cb4e4, {
            "data-testid": (0, (0, parcelRequire("5aF2z")).NO_RESULTS_TEST_ID)
        }, noResultsFallback), results.map((result, index)=>{
            if (result.isGroup) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bYCTm")).CommandPaletteSearchResultGroupItem), {
                ref: (commandRef)=>{
                    if (commandRef) localResultRefs[index] = commandRef;
                },
                group: result.group,
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$GroupContainerComponent, {
                "data-testid": (0, (0, parcelRequire("5aF2z")).GROUP_TEST_ID),
                isFirstResult: index === 0
            }, result.renderGroup ? result.renderGroup() : result.group));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4nfzy")).CommandRowErrorBoundary), {
                key: index,
                teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
                onError: ()=>removeCommandsById([
                        result.command.id
                    ]),
                attributes: (0, (0, parcelRequire("gM5ou")).getRegistryData)(registry, activeRegistry, result?.command.id)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("38IFv")).CommandPaletteSearchResultListItem), {
                ref: (commandRef)=>{
                    if (commandRef) localResultRefs[index] = commandRef;
                },
                id: result.command.id,
                active: result.active,
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eKTyH")).CommandRow), {
                index: index,
                isSearchFieldFocused: isSearchFieldFocused,
                result: result,
                onHoverCommand: (ev)=>{
                    if (ev.movementX === 0 && ev.movementY === 0) return;
                    onHoverCommand(result.index);
                },
                onClickCommand: (event)=>onClickCommand(event, result),
                onMouseDownCommand: onMouseDownCommand
            })));
        }), renderAfterCommands?.({}));
    };
    const $2bc4c9970ded9a96$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
        const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, expandedCommand: expandedCommand, search: search }, { setActiveIndex: setActiveIndex }] = (0, (0, parcelRequire("d8lE2")).useCommandPalette)();
        const [prevActiveIndex, setPrevActiveIndex] = (0, $5uXOq.useState)(activeIndex);
        const resultsRefs = (0, $5uXOq.useRef)([]);
        const modalBodyRef = (0, $5uXOq.useRef)(null);
        const onArrowScroll = (0, $5uXOq.useCallback)((newActiveIndex)=>{
            setActiveIndex(newActiveIndex);
        }, [
            setActiveIndex
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
            setPrevActiveIndex(activeIndex);
            const scrollTo = activeIndex > prevActiveIndex ? (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END : (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).START;
            const scrollToIndex = (0, (0, parcelRequire("64ZBB")).getScrollToIndex)(results, activeIndex, scrollTo);
            const scrolledToResult = resultsRefs.current[scrollToIndex];
            if (scrolledToResult && !(0, (0, parcelRequire("64ZBB")).isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
                const lastIndex = results.length - 1;
                const firstIndex = results.findIndex((result)=>!result.isGroup);
                if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
                else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
                else {
                    if ((0, (0, parcelRequire("4R6GH")).fg)('compal_smooth_transition_on_size_change')) {
                        (0, (0, parcelRequire("64ZBB")).scrollResultIntoView)({
                            target: scrolledToResult,
                            direction: scrollTo,
                            scrollContainer: modalBodyRef.current
                        });
                        return;
                    }
                    (0, (0, parcelRequire("64ZBB")).scrollResultIntoViewOld)(scrolledToResult, scrollTo);
                }
            }
        }, [
            activeIndex,
            prevActiveIndex,
            results
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!modalBodyRef.current?.scrollTo) return;
            modalBodyRef.current.scrollTo(0, 0);
        }, [
            expandedCommand,
            search
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isSearchFieldFocused) return ()=>{};
            const handleArrowScroll = (ev)=>{
                if (ev.key === 'ArrowUp') {
                    ev.preventDefault();
                    activeIndex > 0 && onArrowScroll(activeIndex - 1);
                }
                if (ev.key === 'ArrowDown') {
                    ev.preventDefault();
                    activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
                }
            };
            window.addEventListener('keydown', handleArrowScroll);
            return ()=>{
                window.removeEventListener('keydown', handleArrowScroll);
            };
        }, [
            isSearchFieldFocused,
            total,
            activeIndex,
            setActiveIndex,
            onArrowScroll
        ]);
        const noResultsFallback = (0, $5uXOq.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
            fallback
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cLshs")).CommandPaletteSearchResultListWrapper), {
            ref: modalBodyRef,
            ...(0, (0, parcelRequire("4R6GH")).fg)('a11y_violations_fixes') && {
                noResultsFallback: noResultsFallback
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$CommandPaletteChildren, {
            results: results,
            noResultsFallback: noResultsFallback,
            renderAfterCommands: renderAfterCommands,
            resultsRefs: resultsRefs
        }));
    };
    const $2bc4c9970ded9a96$var$GroupContainerComponent = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_h2xaw7": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _vwz41kw7 _syaz1wmz _1yt41f6d",
                __cmplp.className
            ])
        });
    });
    const $2bc4c9970ded9a96$export$2ab569a6937cb4e4 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_y3gn1h6o _syaz1e9r _1yt4wd81",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bYCTm", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", ()=>$85a6ab23a77e1ea6$export$591c26128e5fd757);
    var $5uXOq = parcelRequire("5uXOq");
    const $85a6ab23a77e1ea6$export$591c26128e5fd757 = (0, $5uXOq.forwardRef)(({ group: group, ...rest }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
            id: group ? `${0, $2350562822a34d03$export$9ed1834ff36a8f29}-${group}` : undefined,
            ...rest
        }));
});
const $2350562822a34d03$export$9ffb4923f81813d9 = 'compal-menu';
const $2350562822a34d03$export$b28d6b416aaf953a = `${$2350562822a34d03$export$9ffb4923f81813d9}-item`;
const $2350562822a34d03$export$9ed1834ff36a8f29 = `${$2350562822a34d03$export$9ffb4923f81813d9}-group`;
const $2350562822a34d03$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $2350562822a34d03$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $2350562822a34d03$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $2350562822a34d03$export$9e40a0642460a944 = 'compal-menu-screen-reader';
parcelRegister("38IFv", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchResultListItem", ()=>$9082b0edc4f10018$export$1f8fa9d1eef77b32);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    const $9082b0edc4f10018$export$1f8fa9d1eef77b32 = (0, $5uXOq.forwardRef)(({ id: id, active: active, ...rest }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref,
            "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
            ...(0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? {
                'aria-current': active,
                role: 'menuitem'
            } : {
                'aria-selected': active,
                role: 'option'
            },
            id: `${(0, $2350562822a34d03$export$b28d6b416aaf953a)}-${id}`,
            ...rest
        }));
});
parcelRegister("cLshs", function(module, exports) {
    $parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", ()=>$42c35fc284860d36$export$95554f6fb39a83c2);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $kgoHi;
    var $8CUq3;
    var $cSD7y;
    var $4R6GH;
    var $koVbs;
    var $zfug2;
    var $6LGvc;
    const $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperNew = (0, $5uXOq.forwardRef)(({ noResultsFallback: noResultsFallback, children: children, as: as, ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const resizerRef = (0, $5uXOq.useRef)(null);
        const height = (0, (0, parcelRequire("6LGvc")).useSmoothExpand)(resizerRef);
        (0, $5uXOq.useEffect)(()=>{
            if (ref && 'current' in ref && ref.current) {
                const currentRef = ref.current;
                currentRef.style.height = `${height}px`;
            }
        }, [
            height,
            ref
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $42c35fc284860d36$var$wrapperStyles,
            testId: (0, $2350562822a34d03$export$85eefac753ab5bdb),
            id: (0, $2350562822a34d03$export$9ffb4923f81813d9),
            role: noResultsFallback && (0, (0, parcelRequire("4R6GH")).fg)('a11y_violations_fixes') ? 'group' : (0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? 'menu' : 'listbox',
            ref: ref,
            "aria-label": formatMessage((0, (0, parcelRequire("zfug2")).messages).commandPaletteSearchResultListBoxLabel),
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            ref: resizerRef,
            direction: "column",
            gap: "space.050"
        }, children));
    });
    const $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperOld = (0, $5uXOq.forwardRef)(({ noResultsFallback: noResultsFallback, ...props }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($42c35fc284860d36$var$Wrapper, {
            "data-testid": (0, $2350562822a34d03$export$85eefac753ab5bdb),
            id: (0, $2350562822a34d03$export$9ffb4923f81813d9),
            role: noResultsFallback && (0, (0, parcelRequire("4R6GH")).fg)('a11y_violations_fixes') ? 'group' : (0, (0, parcelRequire("4R6GH")).fg)('compal_listbox_to_menu') ? 'menu' : 'listbox',
            ref: ref,
            "aria-label": formatMessage((0, (0, parcelRequire("zfug2")).messages).commandPaletteSearchResultListBoxLabel),
            ...props
        });
    });
    const $42c35fc284860d36$export$95554f6fb39a83c2 = (0, (0, parcelRequire("cSD7y")).componentWithFG)('compal_smooth_transition_on_size_change', $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperNew, $42c35fc284860d36$var$CommandPaletteSearchResultListWrapperOld);
    const $42c35fc284860d36$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_c71l4u42 _18m91wug _vchhusvi _1yt41bpf _1e0c1txw _2lx21bp4 _zulp1b66 _1tke8vuz",
                __cmplp.className
            ])
        });
    });
    const $42c35fc284860d36$var$wrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        padding: '0',
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        transition: 'height 0.15s ease-out',
        overflowY: 'auto',
        maxHeight: '376px'
    });
});
parcelRegister("zfug2", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$2745ea1cb0c1a200$export$defe85febe8b728c);
    var $7VHMR;
    const $2745ea1cb0c1a200$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        commandPaletteSearchResultListBoxLabel: {
            "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
            "defaultMessage": "List of commands"
        }
    });
});
parcelRegister("6LGvc", function(module, exports) {
    $parcel$export(module.exports, "useSmoothExpand", ()=>$38452c6bcba6455a$export$674ba8b02d2bfe86);
    var $5uXOq = parcelRequire("5uXOq");
    const $38452c6bcba6455a$var$MAX_HEIGHT = 376;
    const $38452c6bcba6455a$var$STARTING_HEIGHT = 56;
    const $38452c6bcba6455a$var$ADDITIONAL_HEIGHT = 16;
    const $38452c6bcba6455a$export$674ba8b02d2bfe86 = (content)=>{
        const [height, setHeight] = (0, $5uXOq.useState)($38452c6bcba6455a$var$STARTING_HEIGHT);
        const callback = (0, $5uXOq.useCallback)(()=>{
            const contentClientHeight = content.current?.clientHeight;
            if (!contentClientHeight) return;
            if (contentClientHeight > $38452c6bcba6455a$var$MAX_HEIGHT) setHeight($38452c6bcba6455a$var$MAX_HEIGHT);
            else setHeight(contentClientHeight + $38452c6bcba6455a$var$ADDITIONAL_HEIGHT);
        }, [
            content
        ]);
        (0, $5uXOq.useEffect)(()=>{
            let resizeObserver;
            if (content.current && typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(callback);
                resizeObserver.observe(content.current);
            }
            return ()=>{
                if (resizeObserver) resizeObserver.disconnect();
            };
        }, [
            callback,
            content
        ]);
        return height;
    };
});
parcelRegister("4nfzy", function(module, exports) {
    $parcel$export(module.exports, "CommandRowErrorBoundary", ()=>$53a0c321a39d3b85$export$223f3c3c93a14a83);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    const $53a0c321a39d3b85$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "command-palette-row",
            packageName: "jiraCommandPalette",
            fallback: "unmount",
            teamName: teamName,
            onError: onError,
            attributes: attributes
        }, children);
});
parcelRegister("eKTyH", function(module, exports) {
    $parcel$export(module.exports, "CommandRow", ()=>$9e51067b4d29f53f$export$3ef5d254c3c573e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gM5ou;
    var $haBRL;
    const $9e51067b4d29f53f$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
        const { command: command } = result;
        const isActive = !!(result.active && isSearchFieldFocused);
        const isFirstCommand = result.index === 0;
        const rowProps = {
            index: index,
            isActive: isActive,
            command: command,
            isFirstCommand: isFirstCommand,
            onMouseMove: onHoverCommand,
            onClick: onClickCommand,
            onMouseDown: onMouseDownCommand,
            analyticsAttributes: (0, (0, parcelRequire("gM5ou")).getAnalyticsAttributesFromResult)(result)
        };
        if (command.components?.CommandRow) return (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.CommandRow, rowProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("haBRL")).CommandRow), rowProps);
    };
});
parcelRegister("haBRL", function(module, exports) {
    $parcel$export(module.exports, "CommandRow", ()=>$04586313afa284d7$export$3ef5d254c3c573e3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $kgoHi;
    var $8CUq3;
    var $dCm1o;
    var $dzeHJ;
    var $3m7XM;
    var $3sBlN;
    const $04586313afa284d7$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
        const InnerContainer = $04586313afa284d7$var$CommandContainerInner;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainerWrapper, {
            "data-testid": command.id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainer, {
            index: index,
            active: isActive,
            "data-active": isActive,
            "data-testid": (0, $593123af132e266c$export$b0017db5728101cc)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(InnerContainer, {
            "data-testid": (0, $593123af132e266c$export$47c379a40b00a339),
            ...rest
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconAndNameContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandIconsContainer, {
            "data-testid": (0, $593123af132e266c$export$d6dd1cf63aae711c)
        }, command.components?.LeftIcon && ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
            testId: (0, $593123af132e266c$export$7b41978523c7dd4a),
            alignItems: "center",
            justifyContent: "center",
            xcss: [
                $04586313afa284d7$var$iconStyles,
                isActive && $04586313afa284d7$var$iconActiveStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null)) : (0, ($parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconContainer, {
            "data-testid": (0, $593123af132e266c$export$7b41978523c7dd4a),
            active: isActive
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null))), command.mode && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzeHJ")).OutlinedLozenge), {
            "data-testid": (0, $593123af132e266c$export$72c5368f559dd523)
        }, command.mode)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3m7XM")).RenderCommandName), {
            command: command,
            isActive: isActive
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3sBlN")).RightContent), {
            command: command,
            isFirstCommand: isFirstCommand,
            isActive: isActive
        }))));
    };
    const $04586313afa284d7$var$CommandContainerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c81oud _syazjjyb _1yt4swc3",
                !!__cmplp.active && "_syazaj1x _bfhk29zg _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus194a",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandContainerInner = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt467l7 _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandIconsContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwx1b66 _zulp1b66 _1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$iconStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        width: '24px',
        height: '24px',
        color: 'color.icon.subtle'
    });
    const $04586313afa284d7$var$iconActiveStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        color: 'color.icon'
    });
    const $04586313afa284d7$var$CommandLeftIconContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
                __cmplp.active ? "_syaz2zfp" : "_syazbkuv",
                __cmplp.className
            ])
        });
    });
    const $04586313afa284d7$var$CommandLeftIconAndNameContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _16jlkb7n _1o9zkb7n _i0dlf1ug _vwz41tcg _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
const $593123af132e266c$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $593123af132e266c$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $593123af132e266c$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $593123af132e266c$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $593123af132e266c$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';
parcelRegister("3m7XM", function(module, exports) {
    $parcel$export(module.exports, "RenderCommandName", ()=>$c1bc24527d77cdc3$export$931d3f1d35f6c058);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $hWZau;
    var $kgoHi;
    var $8CUq3;
    var $dCm1o;
    var $gGkxR;
    const $c1bc24527d77cdc3$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
        const renderCommandName = (0, $5uXOq.useCallback)(()=>{
            if (command.components?.Name) return (0, ($parcel$interopDefault($5uXOq))).createElement(command.components.Name, {
                isActive: isActive
            }, command.name);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gGkxR")).TruncateWithTooltipOnActive), {
                isActive: isActive
            }, command.name);
        }, [
            command,
            isActive
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandNameContainer, {
            "data-testid": (0, $c5fb72cffbe58dfe$export$1858c2a91b8b53ba),
            active: isActive
        }, command.breadcrumb?.length ? (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbContainer, {
            "data-testid": (0, $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3)
        }, command.breadcrumb.map((BreadCrumb, index, arr)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
                key: index
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbItem, {
                isParent: index !== arr.length - 1,
                "data-testid": (0, $c5fb72cffbe58dfe$export$fb5462105b23e3e5),
                active: isActive
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(BreadCrumb, {
                isActive: isActive
            })), index !== arr.length - 1 && ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kgoHi")).default), {
                justifyContent: "center",
                xcss: $c1bc24527d77cdc3$var$iconWrapperStyles,
                alignItems: "center",
                testId: (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
                color: "currentColor",
                label: "separator"
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandChevronContainer, {
                "data-testid": (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hWZau"))))), {
                color: "currentColor",
                label: "separator"
            })))))) : renderCommandName());
    };
    const $c1bc24527d77cdc3$var$CommandNameContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf _vwz41tcg",
                __cmplp.active ? "_syaz1qfn" : "_syaz1a45",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$CommandBreadcrumbContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$CommandBreadcrumbItem = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_zek046": (0, (0, parcelRequire("lD23V")).default)(__cmplp.active ? `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N400})` : `var(--ds-text-subtlest, ${(0, $829f609a65d26a98$exports).N200})`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                !!__cmplp.isParent && "_syaz1bu1",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$CommandChevronContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vwz4kb7n _syazjwct",
                __cmplp.className
            ])
        });
    });
    const $c1bc24527d77cdc3$var$iconWrapperStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        height: '24px',
        width: '24px'
    });
});
var $829f609a65d26a98$exports = {};
$parcel$export($829f609a65d26a98$exports, "R50", ()=>$829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", ()=>$829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", ()=>$829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", ()=>$829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", ()=>$829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", ()=>$829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", ()=>$829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", ()=>$829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", ()=>$829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", ()=>$829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", ()=>$829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", ()=>$829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", ()=>$829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", ()=>$829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", ()=>$829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", ()=>$829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", ()=>$829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", ()=>$829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", ()=>$829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", ()=>$829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", ()=>$829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", ()=>$829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", ()=>$829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", ()=>$829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", ()=>$829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", ()=>$829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", ()=>$829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", ()=>$829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", ()=>$829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", ()=>$829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", ()=>$829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", ()=>$829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", ()=>$829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", ()=>$829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", ()=>$829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", ()=>$829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", ()=>$829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", ()=>$829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", ()=>$829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", ()=>$829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", ()=>$829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", ()=>$829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", ()=>$829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", ()=>$829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", ()=>$829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", ()=>$829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", ()=>$829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", ()=>$829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", ()=>$829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", ()=>$829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", ()=>$829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", ()=>$829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", ()=>$829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", ()=>$829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", ()=>$829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", ()=>$829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", ()=>$829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", ()=>$829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", ()=>$829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", ()=>$829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", ()=>$829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", ()=>$829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", ()=>$829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", ()=>$829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", ()=>$829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", ()=>$829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", ()=>$829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", ()=>$829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", ()=>$829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", ()=>$829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", ()=>$829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", ()=>$829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", ()=>$829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", ()=>$829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", ()=>$829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", ()=>$829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", ()=>$829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", ()=>$829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", ()=>$829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", ()=>$829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", ()=>$829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", ()=>$829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", ()=>$829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", ()=>$829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", ()=>$829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", ()=>$829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", ()=>$829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", ()=>$829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", ()=>$829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", ()=>$829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", ()=>$829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", ()=>$829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", ()=>$829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", ()=>$829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", ()=>$829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", ()=>$829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", ()=>$829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", ()=>$829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", ()=>$829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", ()=>$829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", ()=>$829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", ()=>$829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", ()=>$829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", ()=>$829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", ()=>$829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", ()=>$829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", ()=>$829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", ()=>$829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", ()=>$829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", ()=>$829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", ()=>$829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", ()=>$829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", ()=>$829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", ()=>$829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", ()=>$829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", ()=>$829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", ()=>$829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", ()=>$829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", ()=>$829f609a65d26a98$export$95e26d54def96891);
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';
parcelRegister("gGkxR", function(module, exports) {
    $parcel$export(module.exports, "TruncateWithTooltipOnActive", ()=>$e999625ec19f201d$export$4495aca3d261add0);
    var $5uXOq = parcelRequire("5uXOq");
    var $1I7E8;
    var $dC5iT;
    var $8CUq3;
    var $k5uoT;
    var $jgArx;
    var $k7xca;
    const $e999625ec19f201d$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1I7E8")).default), {
            isOpen: !!shouldShowTooltip,
            autoFocus: false,
            placement: "bottom-end",
            popupComponent: (0, (0, parcelRequire("jgArx")).PopupComponent),
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TooltipContent), {
                    "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
                }, children),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jgArx")).TriggerComponent), {
                    "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                    ...triggerProps
                }),
            zIndex: (0, (0, parcelRequire("k5uoT")).layers).tooltip()
        });
    const $e999625ec19f201d$export$70f47de153e915ed = ()=>(0, $5uXOq.useRef)(null);
    const $e999625ec19f201d$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
        const containerRef = $e999625ec19f201d$export$70f47de153e915ed();
        const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, (0, parcelRequire("k7xca")).useTruncatedTooltip)({
            containerRef: containerRef,
            tooltipDelay: (0, $40fe2afec35c84b7$export$f9e3e7ede9ba929d)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            ref: containerRef,
            xcss: [
                $e999625ec19f201d$var$tooltipContainerStyles,
                !preventTruncate && $e999625ec19f201d$var$truncateTooltipStyles
            ]
        }, children), isActive && (0, ($parcel$interopDefault($5uXOq))).createElement($e999625ec19f201d$var$TooltipRenderer, {
            shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
        }, showTooltip && customTooltip ? customTooltip : children));
    };
    const $e999625ec19f201d$var$tooltipContainerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        position: 'relative',
        flexGrow: 1,
        textTransform: 'none'
    });
    const $e999625ec19f201d$var$truncateTooltipStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
});
parcelRegister("jgArx", function(module, exports) {
    $parcel$export(module.exports, "TooltipComponent", ()=>$3c6ba86682bb18eb$export$e18e2f8e82cdc428);
    $parcel$export(module.exports, "TriggerComponent", ()=>$3c6ba86682bb18eb$export$534fc570264a52a4);
    $parcel$export(module.exports, "TooltipTrigger", ()=>$3c6ba86682bb18eb$export$8c610744efcf8a1d);
    $parcel$export(module.exports, "PopupComponent", ()=>$3c6ba86682bb18eb$export$9fac2d040f3ed438);
    $parcel$export(module.exports, "TruncateWithTooltipContainer", ()=>$3c6ba86682bb18eb$export$8cae238d61c8405a);
    $parcel$export(module.exports, "TooltipContent", ()=>$3c6ba86682bb18eb$export$e9003e2be37ec060);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $btzsC;
    var $koVbs;
    var $6nFD4;
    const $3c6ba86682bb18eb$export$e18e2f8e82cdc428 = (0, $5uXOq.forwardRef)((props, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledTooltipPrimitive, {
            ...props,
            ref: ref
        }));
    const $3c6ba86682bb18eb$export$534fc570264a52a4 = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$export$8c610744efcf8a1d, {
            ...props,
            role: "button",
            ref: ref,
            "aria-label": formatMessage((0, (0, parcelRequire("6nFD4")).messages).tooltipTriggerAriaLabel)
        });
    });
    const $3c6ba86682bb18eb$export$9fac2d040f3ed438 = (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledPopupPrimitive, {
            ...props,
            ref: ref
        }, children));
    const $3c6ba86682bb18eb$var$StyledTooltipPrimitive = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("btzsC")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$var$StyledPopupPrimitive = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pbydx66 _1bsbp3fh _1yt41ppf _bfhk1j9a _16qsacve",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$export$8cae238d61c8405a = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _o5721q9c _1reo15vq _18m915vq _1bto1l2s _1p1dglyw",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$export$e9003e2be37ec060 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1jfi _11c8qk37",
                __cmplp.className
            ])
        });
    });
    const $3c6ba86682bb18eb$export$8c610744efcf8a1d = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6nFD4", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$87d1d47436abe24f$export$defe85febe8b728c);
    var $7VHMR;
    const $87d1d47436abe24f$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tooltipTriggerAriaLabel: {
            "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
            "defaultMessage": "Command palette tool tip"
        }
    });
});
const $40fe2afec35c84b7$export$f9e3e7ede9ba929d = 400;
parcelRegister("k7xca", function(module, exports) {
    $parcel$export(module.exports, "useTruncatedTooltip", ()=>$ad951546dfa9fa2c$export$94b118b3187f12c);
    var $5uXOq = parcelRequire("5uXOq");
    var $gM5ou;
    const $ad951546dfa9fa2c$export$22c0312879c61300 = ()=>(0, $5uXOq.useState)(false);
    const $ad951546dfa9fa2c$export$1ac6e474a0163418 = ()=>(0, $5uXOq.useState)(false);
    const $ad951546dfa9fa2c$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
        const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $ad951546dfa9fa2c$export$22c0312879c61300();
        const [isTruncated, setIsTruncated] = $ad951546dfa9fa2c$export$1ac6e474a0163418();
        const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, (0, parcelRequire("gM5ou")).useSetTimeoutAutoClear)();
        const setTimeoutFunc = setTimeoutAutoClear;
        (0, $5uXOq.useEffect)(()=>{
            const container = containerRef.current;
            if (!container) return;
            if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
            else setIsTruncated(false);
        }, [
            setIsTruncated,
            containerRef
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isTruncated && tooltipDelay === 0) {
                setShouldShowTruncatedTooltip(true);
                return ()=>{};
            }
            if (isTruncated && tooltipDelay > 0) {
                setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
                return ()=>{};
            }
            setShouldShowTruncatedTooltip(false);
            return ()=>{};
        }, [
            isTruncated,
            setShouldShowTruncatedTooltip,
            tooltipDelay,
            setTimeoutFunc
        ]);
        return {
            shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
        };
    };
});
const $c5fb72cffbe58dfe$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $c5fb72cffbe58dfe$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $c5fb72cffbe58dfe$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';
parcelRegister("3sBlN", function(module, exports) {
    $parcel$export(module.exports, "RightContent", ()=>$a83ca30f957fd273$export$11dbab4b39f15d6b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $h1toL;
    var $koVbs;
    var $gM5ou;
    var $iLhkq;
    var $dSJBv;
    var $kbnU6;
    var $lHtdH;
    const $a83ca30f957fd273$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const transitionStep = (0, (0, parcelRequire("lHtdH")).useHoverTransitionStep)(command, isActive, isFirstCommand);
        const commandHasChildren = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("gM5ou")).hasChildren)(command), [
            command
        ]);
        const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
        if (!shouldRenderRightContent) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$RightContentWrapper, null, commandHasChildren && (0, ($parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$CommandRightChevronContainer, {
            "data-testid": (0, $0296d551a7f83620$export$e3e144c17be58a44),
            transitionStep: transitionStep
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h1toL"))))), {
            label: formatMessage((0, (0, parcelRequire("iLhkq")).messages).rightChevronLabel)
        })), !!command.shortcut && (0, ($parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$ShortcutContainer, {
            "data-testid": (0, $0296d551a7f83620$export$f3036e9d26f81cd9),
            shouldHaveTransition: commandHasChildren,
            transitionStep: transitionStep
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dSJBv")).Shortcuts), {
            shortcut: command.shortcut
        })));
    };
    const $a83ca30f957fd273$var$animationFadeIn = null;
    const $a83ca30f957fd273$var$animationFadeOut = null;
    const $a83ca30f957fd273$var$RightContentWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1a45",
                __cmplp.className
            ])
        });
    });
    const $a83ca30f957fd273$var$CommandRightChevronContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _vwz41tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syazbkuv",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
                __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
                (__cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
                __cmplp.className
            ])
        });
    });
    const $a83ca30f957fd273$var$ShortcutContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "",
                __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
                (__cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("h1toL", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c7fbr;
    var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("3dGN0")));
    function $c6495598d3d7027d$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>$c6495598d3d7027d$var$_react.default.createElement((0, parcelRequire("c7fbr")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
        }, props, {
            newIcon: $c6495598d3d7027d$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
    var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;
});
const $0296d551a7f83620$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $0296d551a7f83620$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';
const $0296d551a7f83620$export$e792b5b2b6c9ee7 = 'command-palette.ui.modal.body.command-right-icon-container';
parcelRegister("iLhkq", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$bf35cee6e1d1204b$export$defe85febe8b728c);
    var $7VHMR;
    const $bf35cee6e1d1204b$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rightChevronLabel: {
            "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
            "defaultMessage": "Command with children icon"
        }
    });
});
parcelRegister("dSJBv", function(module, exports) {
    $parcel$export(module.exports, "Shortcuts", ()=>$57e6d30b2626ce39$export$b326d77e4b8b7664);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $bcTvL;
    var $gM5ou;
    var $dzeHJ;
    var $esPgL;
    const $57e6d30b2626ce39$var$KeyElement = ({ shortcut: shortcut })=>(0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$export$cde89099db64abe3, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzeHJ")).FilledLozenge), {
            "data-testid": (0, $5ecbf01f9da59a15$export$cd62afa4691c297)
        }, shortcut));
    const $57e6d30b2626ce39$var$DivisorElement = ({ divisor: divisor })=>(0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutDivider, {
            "data-testid": (0, $5ecbf01f9da59a15$export$e06ad7c09a29974b)
        }, divisor);
    const $57e6d30b2626ce39$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
        const replacer = replacers.shift();
        if (!replacer) {
            acc.push({
                type: (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY,
                key: shortcut
            });
            types.push((0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY);
            return [
                acc,
                types
            ];
        }
        shortcut.split(replacer.char).forEach((str, index, self)=>{
            $57e6d30b2626ce39$var$parseShortcut(str, replacers.slice(0), acc, types);
            if (index < self.length - 1) {
                acc.push({
                    type: replacer.replacement
                });
                types.push(replacer.replacement);
            }
        });
        return [
            acc,
            types
        ];
    };
    const $57e6d30b2626ce39$export$cfaeb054b183bb20 = ()=>(0, (0, parcelRequire("koVbs")).default)();
    const $57e6d30b2626ce39$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
        const { formatMessage: formatMessage } = $57e6d30b2626ce39$export$cfaeb054b183bb20();
        const [shortcuts, types] = (0, $5uXOq.useMemo)(()=>$57e6d30b2626ce39$var$parseShortcut(shortcut, (0, (0, parcelRequire("gM5ou")).getShortcutSpecialCharacters)()), [
            shortcut
        ]);
        const basicShortcutMessage = (0, $5uXOq.useMemo)(()=>{
            if (types.length === 3) {
                if (types[0] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY) {
                    if (types[1] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).THEN) return (0, (0, parcelRequire("esPgL")).messages).shortcutThen;
                    if (types[1] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).OR) return (0, (0, parcelRequire("esPgL")).messages).shortcutOr;
                    if (types[1] === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).PLUS) return (0, (0, parcelRequire("esPgL")).messages).shortcutPlus;
                }
            }
            return null;
        }, [
            types
        ]);
        const formatTypeToMessage = (0, $5uXOq.useCallback)((type)=>{
            switch(type){
                case (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).THEN:
                    return formatMessage((0, (0, parcelRequire("esPgL")).messages).divisorThen);
                case (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).OR:
                    return formatMessage((0, (0, parcelRequire("esPgL")).messages).divisorOr);
                default:
                    return formatMessage((0, (0, parcelRequire("esPgL")).messages).divisorPlus);
            }
        }, [
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutContainer, {
            "data-testid": (0, $5ecbf01f9da59a15$export$ec8260df4f23714c),
            "aria-hidden": true
        }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
            shortcutA: (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
                shortcut: shortcuts[0].key
            }),
            shortcutB: (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
                shortcut: shortcuts[2].key
            }),
            divisor: (chunk)=>(0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
                    divisor: chunk
                })
        }) : shortcuts.map((obj, index)=>{
            if (obj.type === (0, (0, parcelRequire("bcTvL")).SHORTCUT_ELEMENT_TYPES).KEY) return (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
                key: index,
                shortcut: obj.key
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
                key: index,
                divisor: formatTypeToMessage(obj.type)
            });
        }));
    };
    const $57e6d30b2626ce39$var$ShortcutDivider = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8otz2",
                __cmplp.className
            ])
        });
    });
    const $57e6d30b2626ce39$var$ShortcutContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $57e6d30b2626ce39$export$cde89099db64abe3 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o",
                __cmplp.className
            ])
        });
    });
});
const $5ecbf01f9da59a15$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $5ecbf01f9da59a15$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $5ecbf01f9da59a15$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';
parcelRegister("esPgL", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$4f430d579edd6c91$export$defe85febe8b728c);
    var $7VHMR;
    const $4f430d579edd6c91$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shortcutThen: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
            "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
        },
        shortcutOr: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
            "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
        },
        shortcutPlus: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
            "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
        },
        divisorThen: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
            "defaultMessage": "then"
        },
        divisorOr: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
            "defaultMessage": "or"
        },
        divisorPlus: {
            "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
            "defaultMessage": "+"
        }
    });
});
parcelRegister("kbnU6", function(module, exports) {
    $parcel$export(module.exports, "TRANSITION_STEP", ()=>$d865f5b0afeb3acd$export$42d8d7c94c5a11e9);
    $parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", ()=>$d865f5b0afeb3acd$export$82cfc253a6c33f59);
    $parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", ()=>$d865f5b0afeb3acd$export$e092796a9af3633b);
    $parcel$export(module.exports, "TRANSITION_DURATION_MS", ()=>$d865f5b0afeb3acd$export$1cad4f611a1c0229);
    var $d865f5b0afeb3acd$export$42d8d7c94c5a11e9;
    (function(TRANSITION_STEP) {
        TRANSITION_STEP["INITIAL"] = "initial";
        TRANSITION_STEP["DELAYING"] = "delaying";
        TRANSITION_STEP["TRANSITIONING"] = "transitioning";
        TRANSITION_STEP["FINISHED"] = "finished";
        TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
        TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
    })($d865f5b0afeb3acd$export$42d8d7c94c5a11e9 || ($d865f5b0afeb3acd$export$42d8d7c94c5a11e9 = {}));
    const $d865f5b0afeb3acd$export$82cfc253a6c33f59 = 600;
    const $d865f5b0afeb3acd$export$e092796a9af3633b = 300;
    const $d865f5b0afeb3acd$export$1cad4f611a1c0229 = 350;
});
parcelRegister("lHtdH", function(module, exports) {
    $parcel$export(module.exports, "useHoverTransitionStep", ()=>$9c0e762a7fdf0cdc$export$eefd045a02bab4c6);
    var $5uXOq = parcelRequire("5uXOq");
    var $dWt6p;
    var $jcw0u;
    var $gM5ou;
    var $kbnU6;
    const $9c0e762a7fdf0cdc$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
        const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $5uXOq.useState)(false);
        const [transitionStep, setTransitionStep] = (0, $5uXOq.useState)((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
        const timerRef = (0, $5uXOq.useRef)(null);
        const isReducedMotion = (0, (0, parcelRequire("dWt6p")).useIsReducedMotion)();
        const commandHasChildren = (0, (0, parcelRequire("gM5ou")).hasChildren)(command);
        (0, $5uXOq.useEffect)(()=>{
            setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
            if (timerRef.current) clearTimeout(timerRef.current);
        }, [
            command
        ]);
        const startTimerForNextStep = (nextStep, durationMs)=>{
            timerRef.current = setTimeout(()=>{
                setTransitionStep(nextStep);
                timerRef.current = null;
            }, durationMs);
        };
        const handleReducedMotionTransition = (0, $5uXOq.useCallback)(()=>{
            if (isActive) setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED);
            else setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
        }, [
            isActive
        ]);
        const handleWithMotionTransition = (0, $5uXOq.useCallback)(()=>{
            switch(transitionStep){
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL:
                    if (isActive) {
                        setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING);
                        startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, (0, parcelRequire("kbnU6")).TRANSITION_INITIAL_DELAY_TIME_MS) : (0, (0, parcelRequire("kbnU6")).TRANSITION_HOVER_DELAY_TIME_MS));
                    }
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING:
                    if (!isActive) {
                        timerRef.current && clearTimeout(timerRef.current);
                        timerRef.current = null;
                        setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL);
                    }
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING:
                    if (isActive) {
                        if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                        if (!timerRef.current) startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED, (0, (0, parcelRequire("kbnU6")).TRANSITION_DURATION_MS));
                    }
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).FINISHED:
                    if (!isActive) setTransitionStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT);
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).DELAYING_FADE_OUT:
                    if (!timerRef.current) startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, (0, parcelRequire("kbnU6")).TRANSITION_HOVER_DELAY_TIME_MS));
                    break;
                case (0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                    if (!timerRef.current) startTimerForNextStep((0, (0, parcelRequire("kbnU6")).TRANSITION_STEP).INITIAL, (0, (0, parcelRequire("kbnU6")).TRANSITION_DURATION_MS));
                    break;
                default:
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: new Error('Invalid transition step for command'),
                        meta: {
                            id: 'useTransitionStep',
                            packageName: 'jiraCommandPalette',
                            teamName: 'deliveroo'
                        }
                    });
            }
        }, [
            command.shortcut,
            hasTransitionedFirstCommand,
            isActive,
            isFirstCommand,
            transitionStep
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (commandHasChildren) {
                if (isReducedMotion) handleReducedMotionTransition();
                else handleWithMotionTransition();
            }
        }, [
            commandHasChildren,
            isReducedMotion,
            handleReducedMotionTransition,
            handleWithMotionTransition
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isFirstCommand) setHasTransitionedFirstCommand(false);
        }, [
            isFirstCommand
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                if (timerRef.current) clearTimeout(timerRef.current);
            }, []);
        return transitionStep;
    };
});
parcelRegister("5aF2z", function(module, exports) {
    $parcel$export(module.exports, "GROUP_TEST_ID", ()=>$7ecce3582144481d$export$d83f892940e54128);
    $parcel$export(module.exports, "NO_RESULTS_TEST_ID", ()=>$7ecce3582144481d$export$bf182a53106ca02e);
    $parcel$export(module.exports, "SCROLL_DIRECTION", ()=>$7ecce3582144481d$export$a6d65a8fb7b912d6);
    const $7ecce3582144481d$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
    const $7ecce3582144481d$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
    const $7ecce3582144481d$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
    const $7ecce3582144481d$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
    const $7ecce3582144481d$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
    var $7ecce3582144481d$export$a6d65a8fb7b912d6;
    (function(SCROLL_DIRECTION) {
        SCROLL_DIRECTION["START"] = "start";
        SCROLL_DIRECTION["END"] = "end";
    })($7ecce3582144481d$export$a6d65a8fb7b912d6 || ($7ecce3582144481d$export$a6d65a8fb7b912d6 = {}));
});
parcelRegister("64ZBB", function(module, exports) {
    $parcel$export(module.exports, "isElementVisibleInContainer", ()=>$6b9215d3fa38a855$export$b9dc8b6556026098);
    $parcel$export(module.exports, "getScrollToIndex", ()=>$6b9215d3fa38a855$export$56068eb4c4e3a63c);
    $parcel$export(module.exports, "scrollResultIntoView", ()=>$6b9215d3fa38a855$export$6be8a7238febd54f);
    $parcel$export(module.exports, "scrollResultIntoViewOld", ()=>$6b9215d3fa38a855$export$5ebacb7632dd32c7);
    var $gM5ou;
    var $5aF2z;
    const $6b9215d3fa38a855$export$b9dc8b6556026098 = (element, container)=>{
        const modalBodyRect = container.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();
        return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
    };
    const $6b9215d3fa38a855$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
        const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
        if (scrollTo === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).START && commandResultIndex > 0) {
            const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, (0, parcelRequire("gM5ou")).hasAction)(result.command));
            if (prevActiveCommandIndex === -1) return 0;
        }
        if (scrollTo === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END) {
            const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, (0, parcelRequire("gM5ou")).hasAction)(result.command));
            if (afterActiveCommandIndex === -1) return results.length - 1;
            return commandResultIndex;
        }
        const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
        return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
    };
    const $6b9215d3fa38a855$export$6be8a7238febd54f = ({ target: target, direction: direction, scrollContainer: scrollContainer })=>{
        const targetRect = target.getBoundingClientRect();
        const containerRect = scrollContainer.getBoundingClientRect();
        const gapScroll = 4;
        if (direction === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END) {
            const commandPosition = targetRect.bottom - containerRect.top;
            const amountToScroll = commandPosition - containerRect.height;
            const pos = amountToScroll + gapScroll + scrollContainer.scrollTop;
            scrollContainer.scrollTo({
                top: pos
            });
        } else {
            const commandPosition = containerRect.top - targetRect.top;
            const amountToScroll = scrollContainer.scrollTop - commandPosition;
            const pos = amountToScroll - gapScroll;
            scrollContainer.scrollTo({
                top: pos
            });
        }
    };
    const $6b9215d3fa38a855$export$5ebacb7632dd32c7 = (scrollToResult, scrollTo)=>{
        if (!scrollToResult?.parentElement) return;
        const parent = scrollToResult.parentElement;
        const elemRect = scrollToResult.getBoundingClientRect();
        const parentRect = parent.getBoundingClientRect();
        const gapScroll = 4;
        if (scrollTo === (0, (0, parcelRequire("5aF2z")).SCROLL_DIRECTION).END) {
            const commandPosition = elemRect.bottom - parentRect.top;
            const amountToScroll = commandPosition - parentRect.height;
            const pos = amountToScroll + gapScroll + parent.scrollTop;
            scrollToResult.parentElement.scrollTo({
                top: pos
            });
        } else {
            const commandPosition = parentRect.top - elemRect.top;
            const amountToScroll = parent.scrollTop - commandPosition;
            const pos = amountToScroll - gapScroll;
            scrollToResult.parentElement.scrollTo({
                top: pos
            });
        }
    };
});
parcelRegister("dE25F", function(module, exports) {
    $parcel$export(module.exports, "Footer", ()=>$842574a5e4b1a419$export$a06f1c675e846f6f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $842574a5e4b1a419$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
        const footerChildren = children || defaultFooterContent;
        if (!footerChildren) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($842574a5e4b1a419$var$ModalFooter, {
            "data-testid": (0, $8289a08a5c530859$export$aca3e1b45b29f2bb)
        }, footerChildren);
    };
    const $842574a5e4b1a419$var$ModalFooter = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_mrkb1kw7 _1o0z1kw7 _1yt49l6b _x3doh6cr",
                __cmplp.className
            ])
        });
    });
});
const $8289a08a5c530859$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';
parcelRegister("d4iCz", function(module, exports) {
    $parcel$export(module.exports, "Header", ()=>$82822f3e363fec07$export$8b251419efc915eb);
    var $5uXOq = parcelRequire("5uXOq");
    var $dC5iT;
    var $8CUq3;
    const $82822f3e363fec07$export$8b251419efc915eb = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dC5iT")).default), {
            xcss: $82822f3e363fec07$var$headerStyles,
            testId: (0, $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf)
        }, children);
    const $82822f3e363fec07$var$headerStyles = (0, (0, parcelRequire("8CUq3")).xcss)({
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
        padding: 'space.200',
        borderBottom: `solid 1px ${`var(--ds-border, ${(0, $829f609a65d26a98$exports).N40})`}`
    });
});
const $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';
parcelRegister("8btEA", function(module, exports) {
    $parcel$export(module.exports, "NameContainer", ()=>$ddea451afbf29ad2$export$817b6bdd5f45c94b);
    $parcel$export(module.exports, "IconContainer", ()=>$ddea451afbf29ad2$export$8f314e512d92575f);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $ddea451afbf29ad2$export$817b6bdd5f45c94b = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _2lx2vrvc _1nmz1hna _slp31hna",
                __cmplp.className
            ])
        });
    });
    const $ddea451afbf29ad2$export$8f314e512d92575f = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _18u012x7 _1bsb1tcg _4t3i1tcg _vwz41tcg _1f027vkz _nbgx7vkz",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3XsL2", function(module, exports) {
    $parcel$export(module.exports, "NavigationLink", ()=>$fdfd62bd57e7226d$export$721ee963a67379f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $hDzhb;
    const $fdfd62bd57e7226d$export$721ee963a67379f1 = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4bfu18uv _1hmsglyw _ajmmnqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("d10H0", function(module, exports) {
    $parcel$export(module.exports, "NewTabHintMessage", ()=>$9f2aa76d6a204b23$export$54561b2030abf061);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $jiSaf;
    var $dzeHJ;
    var $2f2jJ;
    var $koVbs;
    var $kdbk3;
    const $9f2aa76d6a204b23$export$54561b2030abf061 = ({ defaultFooterContent: defaultFooterContent })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jiSaf")).components).Footer, null, (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$FooterContentContainer, {
            "data-testid": "command-palette-common.common.ui.new-tab-hint-message"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, defaultFooterContent), (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$HintMessageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$MessageWrapper, null, formatMessage((0, (0, parcelRequire("kdbk3")).messages).openInANewTab)), (0, (0, parcelRequire("2f2jJ")).isMacOs)() ? (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$MacLozenge, null, (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$MacTextOffset, null, "\u2318")) : (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$WindowsLozenge, null, "Ctrl"), (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$EnterLozenge, null, (0, ($parcel$interopDefault($5uXOq))).createElement($9f2aa76d6a204b23$var$EnterIconSVG, null)))));
    };
    const $9f2aa76d6a204b23$var$EnterIconSVG = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "13",
            height: "8",
            viewBox: "0 0 13 8",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M11.055 1.055V3.055H2.275L4.195 1.135C4.455 0.875 4.455 0.455 4.195 0.195C3.935 -0.065 3.515 -0.065 3.255 0.195L0.195 3.255C-0.065 3.515 -0.065 3.935 0.195 4.195L3.255 7.255C3.515 7.515 3.935 7.515 4.195 7.255C4.455 6.995 4.455 6.575 4.195 6.315L2.275 4.38833H11.7217C12.0883 4.38833 12.3883 4.08833 12.3883 3.72167V1.055C12.3883 0.688333 12.0883 0.388333 11.7217 0.388333C11.355 0.388333 11.055 0.688333 11.055 1.055Z",
            fill: `var(--ds-text-subtle, ${(0, $829f609a65d26a98$exports).N600})`
        }));
    const $9f2aa76d6a204b23$var$FooterContentContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1yb4",
                __cmplp.className
            ])
        });
    });
    const $9f2aa76d6a204b23$var$HintMessageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1y6m _syazc8hx _u5f312x7",
                __cmplp.className
            ])
        });
    });
    const $9f2aa76d6a204b23$var$MacLozenge = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("dzeHJ")).OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0v77o _k48p1nn1 _1wybf6fq _vwz47vkz _syazc8hx",
                __cmplp.className
            ])
        });
    });
    const $9f2aa76d6a204b23$var$MacTextOffset = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_t9ec170z",
                __cmplp.className
            ])
        });
    });
    const $9f2aa76d6a204b23$var$WindowsLozenge = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("dzeHJ")).OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1qjk _k48p1nn1 _1p1d1dk0 _syazc8hx",
                __cmplp.className
            ])
        });
    });
    const $9f2aa76d6a204b23$var$EnterLozenge = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("dzeHJ")).OutlinedLozenge), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18u0v77o",
                __cmplp.className
            ])
        });
    });
    const $9f2aa76d6a204b23$var$MessageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _2hwxv77o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kdbk3", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$29cc514acfa3bb8e$export$defe85febe8b728c);
    var $7VHMR;
    const $29cc514acfa3bb8e$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        openInANewTab: {
            "id": "command-palette-common.common.new-tab-hint-message.open-in-a-new-tab",
            "defaultMessage": "Open in a new tab"
        }
    });
});
parcelRegister("dmcoI", function(module, exports) {
    $parcel$export(module.exports, "isCurrentPage", ()=>$b6be5b0653c72ae5$export$d4781f4a7d66b55c);
    const $b6be5b0653c72ae5$export$d4781f4a7d66b55c = (hideCommandPath, pathname)=>{
        const currentPathnameWithoutTrailingSlash = pathname.replace(/\/$/, '');
        const hideCommandPathWithoutTrailingSlash = hideCommandPath?.replace(/\/$/, '');
        return hideCommandPathWithoutTrailingSlash === currentPathnameWithoutTrailingSlash;
    };
});
const $2ea3babd020e8e8a$export$99957d8f5f113509 = 'command-palette-common.controllers.transform-navigation-commands.icon-container';
const $2ea3babd020e8e8a$export$8db96ea7b6a4cbab = 'command-palette-common.controllers.transform-navigation-commands.navigation-link';
parcelRegister("jRhyQ", function(module, exports) {
    $parcel$export(module.exports, "ModalsContainer", ()=>$152d7073d856bfc3$export$5dffa5a5319be22d);
    $parcel$export(module.exports, "ModalsSubscriber", ()=>$152d7073d856bfc3$export$facc296933ebcadf);
    var $gg7kZ;
    var $51nlc;
    var $kUiaM;
    const $152d7073d856bfc3$export$5dffa5a5319be22d = (0, (0, parcelRequire("gg7kZ")).createContainer)((0, (0, parcelRequire("kUiaM")).default));
    const $152d7073d856bfc3$export$facc296933ebcadf = (0, (0, parcelRequire("51nlc")).createSubscriber)((0, (0, parcelRequire("kUiaM")).default), {
        displayName: 'ModalsSubscriber',
        selector: (state)=>state.isOpen
    });
});
parcelRegister("kUiaM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec5c09c48029799e$export$2e2bcd8739ae039);
    var $iXqE5;
    var $cm0Ue;
    const $ec5c09c48029799e$var$initialState = {
        isOpen: false
    };
    var $ec5c09c48029799e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'modals',
        initialState: $ec5c09c48029799e$var$initialState,
        actions: (0, parcelRequire("cm0Ue")).default
    });
});
parcelRegister("cm0Ue", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7e9c601ffd9af0af$export$2e2bcd8739ae039);
    const $7e9c601ffd9af0af$var$actions = {
        open: ()=>({ setState: setState })=>{
                setState({
                    isOpen: true
                });
            },
        close: ()=>({ setState: setState })=>{
                setState({
                    isOpen: false
                });
            }
    };
    var $7e9c601ffd9af0af$export$2e2bcd8739ae039 = $7e9c601ffd9af0af$var$actions;
});
const $d2e2fe4ac38ba530$export$e0515b3bb1ce3f33 = 'viewKeyboardShortcuts';
const $d2e2fe4ac38ba530$export$5f007fc3736b8e2b = 'viewAllIssues';
const $d2e2fe4ac38ba530$export$4e353cf4f7beb2cd = 'createIssue';
const $d2e2fe4ac38ba530$export$42dbd0c9d165bb55 = 'getHelp';
parcelRegister("kTq0U", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$32108244c60f5c7c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $32108244c60f5c7c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        globalShortcuts: {
            "id": "keyboard-shortcuts.global-shortcuts",
            "defaultMessage": "Global shortcuts"
        },
        quickSearch: {
            "id": "keyboard-shortcuts.quick-search",
            "defaultMessage": "Quick search"
        },
        closeDrawer: {
            "id": "keyboard-shortcuts.close-drawer",
            "defaultMessage": "Close drawer"
        },
        createIssue: {
            "id": "keyboard-shortcuts.create-issue",
            "defaultMessage": "Create issue"
        },
        keyboardShortcuts: {
            "id": "keyboard-shortcuts.keyboard-shortcuts",
            "defaultMessage": "Keyboard shortcuts"
        },
        keyboardShortcutsCommandPalette: {
            "id": "keyboard-shortcuts.keyboard-shortcuts-command-palette",
            "defaultMessage": "View keyboard shortcuts"
        },
        findIssues: {
            "id": "keyboard-shortcuts.find-issues",
            "defaultMessage": "Find issues"
        },
        browseAProject: {
            "id": "keyboard-shortcuts.browse-a-project",
            "defaultMessage": "Browse to a project"
        },
        toggleSidebar: {
            "id": "keyboard-shortcuts.toggle-sidebar",
            "defaultMessage": "Toggle sidebar"
        },
        openHelpPanel: {
            "id": "keyboard-shortcuts.open-help-panel",
            "defaultMessage": "Open help panel"
        },
        openCommandPalette: {
            "id": "keyboard-shortcuts.open-command-palette",
            "defaultMessage": "Open command palette"
        },
        quickSearchCommand: {
            "id": "keyboard-shortcuts.quick-search-command",
            "defaultMessage": "Open quick search"
        },
        getHelp: {
            "id": "keyboard-shortcuts.get-help",
            "defaultMessage": "Get help"
        },
        viewAllIssues: {
            "id": "keyboard-shortcuts.view-all-issues",
            "defaultMessage": "View all issues"
        }
    });
});
parcelRegister("flygU", function(module, exports) {
    $parcel$export(module.exports, "getShortcutModifierKey", ()=>$7b810681a5f73457$export$fe66dae91c68619b);
    const $7b810681a5f73457$var$isMacOs = ()=>/Mac/i.test(window?.navigator?.platform);
    const $7b810681a5f73457$export$fe66dae91c68619b = ()=>$7b810681a5f73457$var$isMacOs() ? 'meta' : 'ctrl';
});
